import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { TestInCenter } from '../_models/center-test.model';
import { Center, CenterType } from '../_models/center.model';
import { HomeVisitFee } from '../_models/homeVisitFees.model';

@Injectable({
  providedIn: 'root',
})
export class CentersService {
  centerUrl = 'api/Center';
  centerTypes = 'api/CenterTypes';
  centerTests = 'api/AdminCenterTests/';
  homeFeesUrl = 'api/CenterHomeVisitFees/';
  getCenterByTypeIdUrl: string = 'api/Center/GetCentersByTypeId';
  searchCenterByNameUrl: string = 'api/Center/SearchByName';
  searchCenterTestByNameUrl: string = 'api/AdminCenterTests/SearchByName';
  getServiceProviderUrl: string = 'api/NetworkProvider';
  // centerTypes: CenterType[] = [{ id: 1, name: 'Lab', arName: 'معمل' }];

  constructor(private http: HttpClient) { }

  getAllCenters(): Observable<any> {
    return this.http.get(this.centerUrl + '/GetAllAdminCenters');
  }

  getCentersByTypeId(typeId: number): Observable<any> {
    let params = new HttpParams().set('typeId', typeId.toString())
    return this.http.get(this.getCenterByTypeIdUrl, { params });
  }

  getCenterById(id: number): Observable<any> {
    return this.http.get(`${this.centerUrl}/${id}`);
  }


  addCenter(image, payload: Center): Observable<any> {
    const formData = new FormData();
    image && formData.append('logoForm', image, image.name);
    formData.append('name', payload.name);
    formData.append('arName', payload.arName);
    formData.append('phone', payload.phone);
    formData.append('email', payload.email);
    formData.append('countryId', payload.countryId.toString());
    formData.append('centerTypeId', payload.centerTypeId.toString());
    formData.append('isActive', payload.isActive.toString());

    return this.http.post(this.centerUrl, formData);
  }

  deleteCenter(id: number): Observable<any> {
    return this.http.delete(`${this.centerUrl}/${id}`);
  }

  updateCenter(image, payload: Center): Observable<any> {
    const formData = new FormData();

    if (image) {
      formData.append('logoForm', image, image.name);
    } else {
      formData.append('logoForm', null);
    }
    formData.append('id', payload.id.toString());
    formData.append('name', payload.name);
    formData.append('arName', payload.arName);
    formData.append('phone', payload.phone);
    formData.append('email', payload.email);
    formData.append('countryId', payload.countryId.toString());
    formData.append('centerTypeId', payload.centerTypeId.toString());
    formData.append('isActive', payload.isActive.toString());

    return this.http.put(this.centerUrl, formData);
  }

  getAllCenterTypes(): any {
    return this.http.get(`${this.centerTypes}`);
  }


  getAllTestsInCenter(centerId: number): Observable<any> {
    return this.http.get(`${this.centerTests}GetAllByCenterId/${centerId}`);
  }

  saveTestsForCenter(test): Observable<any> {
    return this.http.post(`${this.centerTests}AddTestsForLabs`, test);
  }

  addHomeFeesVisits(homeFee: HomeVisitFee): Observable<any> {
    return this.http.post(`${this.homeFeesUrl}`, homeFee);
  }

  getAllFeesInCenter(centerId): Observable<any> {
    return this.http.get(`${this.homeFeesUrl}GetAllByLabId/${centerId}`);
  }

  getFeeById(id): Observable<any> {
    return this.http.get(`${this.homeFeesUrl}/${id}`);
  }

  updateFee(homeFee: HomeVisitFee): Observable<any> {
    return this.http.put(`${this.homeFeesUrl}`, homeFee);
  }

  deleteFee(id): Observable<any> {
    const params = {
      id
    };
    return this.http.get(`${this.homeFeesUrl}`, { params });
  }

  searchCenterByName(centerName, typeId) {
    let params = new HttpParams()
      .set('name', centerName)
      .set('typeId', typeId);
    return this.http.get(this.searchCenterByNameUrl, { params });
  }

  searchCenterTestByName(testName: string, centerId: number) {
    let params = new HttpParams()
      .set('name', testName)
      .set('centerId', centerId.toString())
    return this.http.get(this.searchCenterTestByNameUrl, { params });
  }

  getServiceProviderById(typeId: number): Observable<any> {
    return this.http.get(`${this.getServiceProviderUrl}/${typeId}`);;
  }
}
